module.exports = __webpack_public_path__ + "static/media/ic_delivery_black.cdcb6718.svg";